/*
 * An SVGO plugin to validate that an item will be acceptable for PIXI JSON; it does no conversions, just validates
 */
import { keys, equals, path } from 'ramda'

const error = (item, message) => {
    const path = i => i.parentNode ? `${ path(i.parentNode) }|${ i.elem }` : i.elem

    console.log(`  ${ path(item) }; ${ message }`)
}

const validateAttributes = (expectedKeys, item) => {
    const attributes = item.attrs
    const expected = expectedKeys.sort()
    const actual = keys(attributes).sort()

    if (!equals(expected, actual))  {
        error(item, `expected attributes [${ expected.join(', ') }] but found [${ actual.join(', ') }]`)
    }
}

/*
 * Validate that a "path" shape is valid for conversion to PIXI JSON
 */
const pathValidator = item => {
    const d                   = path(['attrs', 'd', 'value'], item)
    const illegalInstructions = /[AHQSTVZachlmqstvz]/  // leaving only M, L and C

    validateAttributes(['fill', 'd'], item)

    if (!d.match(/^M/))               error(item, `path should start with M`)
    if (d.match(illegalInstructions)) error(item, `illegal instruction ${ d.match(illegalInstructions) } in ${ d }`)
}

/*
 * Table of validators based on element type; any element not in the table is illegal by definition.
 */
const validators = {
    svg : () => { /* nothing to do? */ },
    g   : item => validateAttributes([], item),
    path: pathValidator,
}

// validate a "processing instruction" (eg. <?xml ... />
const validateProcessingInstruction = processingInstruction => {
    if (processingInstruction.name !== 'xml') {
        error(processingInstruction, `incompatible processing instruction: ${ processingInstruction }`)
    }
}

/*
 * Main plugin function
 */
const fn = item => {
    if (item.processinginstruction) return validateProcessingInstruction(item.processinginstruction)

    const validator  = validators[item.elem]
    validator ? validator(item) : error(item, `illegal element ${ item.elem }`)
}


const validateCompatibilityWithPixi = {
    type        : 'perItem',
    active      : true,
    description : 'Validate that the SVG contains only elements that can be ported to PIXI',
    params      : {},
    fn,
}


export { validateCompatibilityWithPixi }



